import DapDSCopyBoxInput from './copybox-input.component'

export * from './copybox-input.component'
export default DapDSCopyBoxInput

DapDSCopyBoxInput.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-copybox-input': DapDSCopyBoxInput
  }
}
